import React from "react";
import "./InLine.css";

const InLine = ({ children }) => (
  <div className="flex gap-4 mb-4 stats">{children}</div>
);

export default InLine;
